<template>
  <div
    class="
      hidden
      lg:flex
      lg:flex-col
      lg:w-64
      lg:fixed
      lg:inset-y-0
      lg:border-r
      lg:border-gray-200
      lg:pt-5
      lg:pb-4
      lg:bg-gray-50
    "
  >
    <div class="flex items-center flex-shrink-0 px-6">
      <img class="h-20 w-auto" src="/images/logo.svg" alt="Workflow" />
    </div>
    <!-- Sidebar component, swap this element with another sidebar if you like -->
    <div class="mt-6 h-0 flex-1 flex flex-col overflow-y-auto">
      <!-- User account dropdown -->
      <Menu as="div" class="px-3 relative inline-block text-left">
        <div>
          <MenuButton
            class="
              group
              w-full
              bg-white
              rounded-md
              px-3.5
              py-2
              text-sm text-left
              font-medium
              text-gray-700
              hover:bg-gray-100
              focus:outline-none
              focus:ring-2
              focus:ring-offset-2
              focus:ring-offset-gray-100
              focus:ring-blue-500
            "
          >
            <span class="flex w-full justify-between items-center">
              <span class="flex min-w-0 items-center justify-between space-x-3">
                <ui-avatar
                  backgroundStyling="bg-light-blue-200"
                  textStyling="text-white"
                  sizeStyling="h-10 w-10 flex-shrink-0"
                />

                <span class="flex-1 flex flex-col min-w-0">
                  <span class="text-gray-900 text-sm font-medium truncate">{{
                    $page.props.user.data.name
                  }}</span>
                  <span class="text-gray-500 text-sm truncate">{{
                    t($page.props.user.data.account.type)
                  }}</span>
                </span>
              </span>
              <SelectorIcon
                class="
                  flex-shrink-0
                  h-5
                  w-5
                  text-gray-400
                  group-hover:text-gray-500
                "
                aria-hidden="true"
              />
            </span>
          </MenuButton>
        </div>
        <transition
          enter-active-class="transition ease-out duration-100"
          enter-from-class="transform opacity-0 scale-95"
          enter-to-class="transform opacity-100 scale-100"
          leave-active-class="transition ease-in duration-75"
          leave-from-class="transform opacity-100 scale-100"
          leave-to-class="transform opacity-0 scale-95"
        >
          <MenuItems
            class="
              z-10
              mx-3
              origin-top
              absolute
              right-0
              left-0
              mt-1
              rounded-md
              shadow-lg
              bg-white
              ring-1 ring-black ring-opacity-5
              divide-y divide-gray-200
              focus:outline-none
            "
          >
            <div
              v-for="(menuSection, menuSectionindex) in profileMenu"
              :key="menuSectionindex"
              class="py-1"
            >
              <MenuItem
                :key="menuItem.route"
                v-for="menuItem in menuSection"
                v-slot="{ active }"
              >
                <Link
                  :method="menuItem.method ? menuItem.method : ''"
                  :href="route(menuItem.route)"
                  :class="[
                    active ? 'bg-gray-100 text-gray-900' : 'text-gray-700',
                    'block px-4 py-2 text-sm',
                  ]"
                  >{{ menuItem.text }}</Link
                >
              </MenuItem>
            </div>
          </MenuItems>
        </transition>
      </Menu>
      <!-- Sidebar Search -->
      <!-- <div class="px-3 mt-5">
        <label for="search" class="sr-only">Search</label>
        <div class="mt-1 relative rounded-md shadow-sm">
          <div
            class="
              absolute
              inset-y-0
              left-0
              pl-3
              flex
              items-center
              pointer-events-none
            "
            aria-hidden="true"
          >
            <SearchIcon class="mr-3 h-4 w-4 text-gray-400" aria-hidden="true" />
          </div>
          <input
            type="text"
            name="search"
            id="search"
            class="
              focus:ring-blue-500 focus:border-blue-500
              block
              w-full
              pl-9
              sm:text-sm
              border-gray-300
              rounded-md
            "
            placeholder="Search"
          />
        </div>
      </div> -->
      <!-- Navigation -->
      <nav class="px-3 mt-6">
        <div class="space-y-1">
          <div v-for="(menuItem, index) in menu" :key="menuItem.text">
            <button
              v-if="'children' in menuItem && menuItem.children.length > 0"
              @click="
                menuCollapsedToggles[index] = !menuCollapsedToggles[index]
              "
              class="
                w-full
                group
                flex
                items-center
                px-2
                py-2
                text-sm
                leading-5
                font-medium
                rounded-md
                focus:outline-none
                transition
                ease-in-out
                duration-150
                text-gray-700
                hover:text-light-blue-600 hover:bg-light-blue-50
              "
            >
              <component
                class="
                  text-gray-400
                  mr-3
                  h-6
                  w-6
                  group-hover:text-light-blue-400
                  transition
                  ease-in-out
                  duration-150
                "
                :is="menuItem.iconComponent"
              />
              {{ menuItem.text }}
            </button>

            <Link
              v-else
              :href="route(menuItem.route)"
              :class="{
                'text-light-blue-600 bg-light-blue-50': route().current(
                  menuItem.route
                ),
                'text-gray-700 hover:text-light-blue-600 hover:bg-light-blue-50':
                  !route().current(menuItem.route),
              }"
              class="
                group
                flex
                items-center
                px-2
                py-2
                text-sm
                leading-5
                font-medium
                rounded-md
                focus:outline-none focus:bg-light-blue-50
                transition
                ease-in-out
                duration-150
              "
            >
              <component
                class="
                  mr-3
                  h-6
                  w-6
                  group-hover:text-light-blue-400
                  transition
                  ease-in-out
                  duration-150
                "
                :class="
                  route().current(menuItem.route)
                    ? 'text-light-blue-400'
                    : 'text-gray-400'
                "
                :is="menuItem.iconComponent"
              />
              {{ menuItem.text }}
            </Link>

            <div
              class="mt-1 space-y-1"
              v-if="'children' in menuItem && menuItem.children.length > 0"
              v-show="menuCollapsedToggles[index]"
            >
              <Link
                v-for="(submenuItem, subindex) in menuItem.children"
                :key="subindex"
                :href="route(submenuItem.route)"
                class="
                  group
                  w-full
                  flex
                  items-center
                  pl-10
                  pr-2
                  py-2
                  text-sm
                  leading-5
                  font-medium
                  text-gray-600
                  rounded-md
                  hover:text-light-blue-600 hover:bg-light-blue-50
                  focus:outline-none
                  focus:text-light-blue-500
                  focus:bg-light-blue-50
                  transition
                  ease-in-out
                  duration-150
                "
                >{{ submenuItem.text }}</Link
              >
            </div>
          </div>
        </div>
      </nav>
    </div>
  </div>
</template>

<script>
import {
  HomeIcon,
  CalendarIcon,
  UsersIcon,
  UserGroupIcon,
  ShieldCheckIcon,
  ViewGridIcon,
  BeakerIcon,
  DocumentTextIcon,
  UserIcon,
  SelectorIcon,
  DesktopComputerIcon,
  SearchIcon,
} from "@heroicons/vue/outline";

import { Menu, MenuItems, MenuItem, MenuButton } from "@headlessui/vue";

import { useI18n } from "vue-i18n";

export default {
  components: {
    HomeIcon,
    CalendarIcon,
    UsersIcon,
    UserGroupIcon,
    ShieldCheckIcon,
    ViewGridIcon,
    BeakerIcon,
    DocumentTextIcon,
    UserIcon,
    SelectorIcon,
    DesktopComputerIcon,
    SearchIcon,
    Menu,
    MenuItems,
    MenuItem,
    MenuButton,
  },
  props: {
    profileMenu: {
      type: Array,
      required: true,
    },
    menu: {
      type: Array,
      required: true,
    },
  },

  setup() {
    const { t } = useI18n();
    return { t };
  },

  data() {
    return {
      profileToggle: false,
      searchQuery: "",
      menuCollapsedToggles: {},
    };
  },

  mounted() {
    this.menu.forEach((element, index) => {
      if ("children" in element && element.children.length > 0) {
        this.$set(this.menuCollapsedToggles, index, false);
      }
    });
  },
};
</script>

<i18n>
{
  "es": {
    "administrator": "Administrador",
    "employee": "Empleado",
    "technician": "Signatario"
  }
}
</i18n>